import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Box, Button, Paper, TextField, Typography, Grid, Stack } from '@mui/material';
import { getAllMatchPeriods, getPlayedGamesPeriods, getSurchargePeriod, getTimerList, getTotalTimer, getVisualTimer } from '../sports/rules.js';
import Item from '../gameFact/generic/Item.js';

const PeriodTimerSelector = ({ match, onPeriodChange, onTimerChange, updateRecapData}) => {

    const [isCollapsed, setIsCollapsed] = useState(true);

    const [selectedPeriod, setSelectedPeriod] = useState();
    const [selectedTimer, setSelectedTimer] = useState();
    const [userModified, setUserModified] = useState(false); // Indique si l'utilisateur a modifié un input

    const [error, setError] = useState()

    useEffect(() => {
        if(match.status === 'end')
            setIsCollapsed(false)

    }, [match.status])


    useEffect(() => {
        // Synchroniser les valeurs de `selectedPeriod` et `selectedTimer` avec `match` tant que l'utilisateur n'a pas modifié
        if (!userModified) {
            let period = match.period;
            if (['handball'].includes(match.discipline)) {
                period = getSurchargePeriod(match.discipline, match.period) || match.period;
            }
            setSelectedPeriod(period);
            onPeriodChange(period);

            let timer = getTotalTimer(match.period, match.timer, match.discipline)
            if(match.statusTimer === 'on' || match.timer !== 0){
                timer += 60
            }

            timer = Math.floor(timer/60)

            setSelectedTimer(timer);
            onTimerChange(timer);

            // Period
            const periodObject = periodList.find(p => p.matchPeriod == period)
            updateRecapData({period : periodObject.name, timer : timer})
        }
    }, [, match.period, match.timer, userModified, match.statusTimer]);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handlePeriodChange = (period) => {

        setError(undefined)

        let newPeriod = period

        /*if(['handball'].includes(match.discipline)){
            newPeriod = getSurchargePeriod(match.discipline, newPeriod);
        }*/

        setSelectedPeriod(newPeriod);
        setUserModified(true); // L'utilisateur a modifié un input
    };

    const handleTimerChange = (e) => {

        setError(undefined)

        const newTimer = Number.parseInt(e.target.value);

        setUserModified(true); // L'utilisateur a modifié un input
        setSelectedTimer(newTimer)
    };

    const handleSubmit = () => {

        let periodValue =  selectedPeriod
        if (match.discipline==='handball' && !periodValue){
            const nextPer = getSurchargePeriod(match.discipline, match.period);
            periodValue = nextPer ? nextPer : selectedPeriod;
        }

        let max = 60
        let timerList = getTimerList(periodValue, max, match.discipline)
        const mappedTimer = timerList.find(t => t.value == selectedTimer)

        if(mappedTimer){
            onTimerChange(mappedTimer.id);
            onPeriodChange(periodValue);
            setError(undefined)

            // Period
            const periodObject = periodList.find(p => p.matchPeriod == selectedPeriod)
            const visualTimer = getVisualTimer(periodObject.matchPeriod, mappedTimer.id, match.discipline)
            updateRecapData({period : periodObject.name, timer : visualTimer})
        }else{
            
            let expectedValue = 0
            let message = 'Le chrono saisi est '

            if(selectedTimer < timerList[0].value){
                message += 'inférieur'
                expectedValue = timerList[0].value
            }else if(selectedTimer > timerList[timerList.length-1].value){
                message += 'supérieur'
                expectedValue = timerList[timerList.length-1].value
            }

            message += ' à la valeur attendue ( '+expectedValue+' ).'
            setError(message)
        }
    }


    const handleReset = () => {
        setUserModified(false); // Réinitialiser l'état de modification utilisateur
        onPeriodChange(match.period);
        onTimerChange(match.timer);
    };

    const periodList = useMemo(() => {
        const periods = []

        if(['handball'].includes(match.discipline)){

            const allPeriods = getAllMatchPeriods(match.discipline);
            const allPlayablePeriods = getPlayedGamesPeriods(match.discipline);
            const periodsToDisplay = new Map();

            for (const [key, value] of allPlayablePeriods) {
                if (key <= match.period) {
                    periodsToDisplay.set(value.matchPeriod, value);
                } else {
                    if (!allPeriods.get(match.period).isPlayable){
                        periodsToDisplay.set(value.matchPeriod, value);
                    }
                    break;
                }
            }

            if(match.period === 10){
                const endGame = allPeriods.get(10)
                periodsToDisplay.set(10, endGame)
            }

           for (const [matchPeriod, period] of periodsToDisplay) {
            periods.push(period)
           }

        }else{
            //Other disciplines
            const periodNames = ['Période 1', 'Période 2',,'Prolongation 1', 'Prolongation 2', 'Tirs au but']
            for(var i = 0; i <= match.period ; i++){
                let actualInLoop = i
                let period
                if(['rugby', 'soccer'].includes(match.discipline)){
                    if([2,6].includes(match.period) && actualInLoop === match.period){
                        period = { 
                            name : "Fin du match",
                            matchPeriod : actualInLoop
                        }
                        periods.push(period)
                    }else if(actualInLoop !== 2 && actualInLoop !== 6){
                        period = { 
                            name : periodNames[actualInLoop],
                            matchPeriod : actualInLoop
                        }
                        periods.push(period)
                    }
                }else{
                    period = { 
                        name : "Periode "+ (actualInLoop+1),
                        matchPeriod : actualInLoop
                    }
                    periods.push(period)
                }    
            }
        }

        return periods

    }, [match.period, selectedPeriod])

    return (
        <Paper sx={{ 
            mt: '1rem', mb : '1rem', p : '1rem',
            height: isCollapsed ? '2rem' : 'auto', // Change la hauteur si collapsed
            overflow: 'hidden', // Cache le contenu lorsque le composant est réduit
            transition: 'height 0.3s ease' // Animation de transition
        }}>
            <Grid container alignItems="center" justifyContent="space-between" position='relative'>
                <Typography 
                sx={{
                    '&:hover' : {
                        cursor : 'pointer'
                    }
                }}
                onClick={toggleCollapse} variant="h6" textAlign={'center'} width='100%'>
                    Sélecteur de Période et Chrono
                    
                </Typography>
                <Button 
                sx={{
                    position : 'absolute',
                    top : 0,
                    right : 0
                }}
                onClick={toggleCollapse} variant="contained" size="small">
                        {isCollapsed ? 'Déplier' : 'Réduire'}
                </Button>
            </Grid>

        {/* Afficher le contenu seulement si non réduit */}
        {!isCollapsed && (<><Grid container spacing={2}>
            <Grid item xs={8}>
                <Typography variant="body1" sx={{ marginBottom: '8px', width: 'fit-content' }}>Sélectionner la période de saisie</Typography>
                <Grid container spacing={1} alignItems={'center'} pr={'5rem'}>
                    {periodList.map((period) => (
                        <Grid item key={period.id} xs={12} md={3}>
                            <Item
                                selected={selectedPeriod}
                                onSelect={handlePeriodChange}
                                value={`${period.name}`}
                                id={period.matchPeriod}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="body1" sx={{ marginBottom: '8px', width: 'fit-content' }}>Sélectionner le chrono (minutes)</Typography>
                        <TextField
                            type="number"
                            value={selectedTimer}
                            onChange={(e) => handleTimerChange({ target: { value: e.target.value } })}
                            fullWidth
                            onFocus={(e) => e.target.select()} // Sélectionner tout le texte lorsque l'input reçoit le focus
                            error={!!error} // Affiche l'état d'erreur si error contient un message
                            helperText={error} // Affiche le message d'erreur
                        />
            </Grid>
        </Grid>
        <Box display={'flex'} justifyContent={'center'} mt={'1rem'} gap={2}>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Valider
                </Button>
                <Button onClick={handleReset} variant="contained" color="primary" disabled={!userModified}>
                    Réinitialiser
                </Button>
        </Box></>)}
    </Paper>
    );
};

export default PeriodTimerSelector;
